import React from "react";
import { Box, Typography, Paper, Divider, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const PaymentStatus = ({ status }) => {
  return (
    <Box>
      {status.success ? (
        <>
          <Box textAlign="center" color="success.main" mb={2}>
            <CheckCircleIcon sx={{ fontSize: 60 }} />
            <Typography variant="h5" gutterBottom>
              Payment Successful!
            </Typography>
            <Typography variant="body1" paragraph>
              Thank you for your payment.
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{ p: 2, mb: 3, bgcolor: "background.paper" }}
          >
            <Typography variant="subtitle1" gutterBottom>
              Transaction Details
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography variant="body2">Amount:</Typography>
              <Typography variant="body2" fontWeight="bold">
                ${status.data.data.amount}
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography variant="body2">Transaction ID:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {status.data.data.payment_id}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Date:</Typography>
              <Typography variant="body2" fontWeight="bold">
                {new Date(status.data.data.created_time).toLocaleString()}
              </Typography>
            </Box>
          </Paper>
        </>
      ) : (
        <Box textAlign="center" color="error.main">
          <ErrorIcon sx={{ fontSize: 60 }} />
          <Typography variant="h5" gutterBottom>
            Payment Failed
          </Typography>
          <Typography variant="body1" paragraph>
            {status.error?.message || "Please try again later."}
          </Typography>
          <Button
            variant="outlined"
            color="error"
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PaymentStatus;
